import React from 'react';
import { Button, Spinner } from 'reactstrap';

type IProps = {
  title?: string,
  text?: string,
  color: string
  onClick?: () => void,
  isLoading?: boolean
  customBtnStyle?: string,
  customSpinnerStyle?: string,
  buttonRef?: any,
  icon?: React.ReactNode,
  disabled?: boolean,
  style?: React.CSSProperties
}

const CustomButton: React.FC<IProps> = ({title, text, color, isLoading, onClick, customBtnStyle, customSpinnerStyle, buttonRef, icon, disabled = false, style }) => {
  return (
    <Button color={color} title={title} onClick={onClick} className={customBtnStyle ? customBtnStyle : ''} innerRef={buttonRef} disabled={disabled} style={style}>
      <span className={`position-relative d-inline-flex align-items-center justify-content-center ${isLoading ? 'spinner-loader' : ''}`}>
        {isLoading ? <Spinner size="sm" className={`${customSpinnerStyle ? customSpinnerStyle : ''}`} /> : '' }
        { text }
        {icon ? icon : null}
      </span>
    </Button>
  )
}

export default CustomButton;